export default "__VITE_ASSET__ShFyF5Yp__"